import { useState } from 'react';

import { useAppDispatch } from 'app/hooks';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { UsersAccessByAclReportRequest } from 'common/services/api/Reports/UsersAccessByAcl.api';
import { fetchUsersAccessByAcl } from 'common/services/api/Reports/UsersAccessByAcl.thunk';
import { handleListFetchError } from 'common/utils/errorHandlers';
import { useSnackbar } from 'notistack';

export const useProcessFetchAclResourcesUserListReportData = (
    tenantId: string | undefined,
    request: UsersAccessByAclReportRequest
) => {
    const [processing, setProcessing] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const _handleError = (error: unknown) => {
        const err = error as Error;
        const statusCode = extractStatusCode(err.message);
        handleListFetchError(statusCode, 'User Group ACLs report', enqueueSnackbar);
        setProcessing(false);
    };

    const processFetchAclResourcesUserListReportData = async () => {
        if (!tenantId) return;

        setProcessing(true);

        try {
            return await dispatch(fetchUsersAccessByAcl({ tenantId, request })).unwrap();
        } catch(error) {
            _handleError(error);
            return [];
        } finally {
            setProcessing(false);
        }
    };

    return { processing, processFetchAclResourcesUserListReportData };
};
